import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogInner,
  DialogTitle,
} from "@/components/ui/dialog";

interface NavigationBlockDialogProps {
  open: boolean;
  title?: string;
  message?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function NavigationBlockDialog({
  open,
  title = "Leave Active Session?",
  message = "You have an active session. Are you sure you want to leave?",
  onConfirm,
  onCancel,
}: NavigationBlockDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogInner>{message}</DialogInner>
        <DialogFooter>
          <Button variant="solid" intent="danger" onClick={onConfirm}>
            Leave Session
          </Button>
          <Button
            variant="outline"
            css={{ minWidth: 100 }}
            intent="secondary"
            onClick={onCancel}
          >
            Stay
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
